import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MedicalImagesPanelComponent } from './medical-images-panel.component';

@NgModule({
  declarations: [MedicalImagesPanelComponent],
  imports: [CommonModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatIconModule, MatProgressSpinnerModule],
  exports: [MedicalImagesPanelComponent],
})
export class MedicalImagesPanelModule {}
